import React from "react";
import { LocationProvider } from "@reach/router";
import AccountProvider from "./account";
import CartProvider from "./cart";
import ProductFinderProvider from "./product-finder";
import SearchProvider from "./search";
import VisualSearchProvider from "./visual-search";

const GlobalProvider = ({ children }) => {
    const [isHydrated, setIsHydrated] = React.useState(false);

    React.useEffect(() => {
        setIsHydrated(true);
    }, []);

    return (
        <div className={isHydrated ? "hydrated" : "not-hydrated"}>
            <AccountProvider>
                <CartProvider>
                    <ProductFinderProvider>
                        <SearchProvider>
                            <VisualSearchProvider>
                                <LocationProvider>
                                    {children}
                                </LocationProvider>
                            </VisualSearchProvider>
                        </SearchProvider>
                    </ProductFinderProvider>
                </CartProvider>
            </AccountProvider>
        </div>
    );
};

export default GlobalProvider;
